import styled from '@emotion/styled/macro';
import theme from 'ui/theme/theme';
import { Flex } from '@chakra-ui/react';

export const StyledTable = styled.table`
  width: 100%;
  border-spacing: 0;
  border-collapse: collapse;
  margin-bottom: 36px;
`;

export const StyledTd = styled.td`
  padding: ${(props) => props.p || '26px 24px'};
  background: ${(props) =>
    props.isEven ? theme.colors.gray['0'] : theme.colors.gray['100']};
  &.rightAlign {
    text-align: end;
  }
  &.center {
    text-align: center;
  }
`;

export const StyledTr = styled.tr`
  border: 1px solid ${theme.colors.semantics.disabled};
`;

export const StyledTh = styled.th`
  font-weight: normal;
  background: ${theme.colors.gray['50']};
  padding: ${(props) => props.p || '26px 24px'};
  &.large {
    width: 220px;
  }
  &.leftAlign {
    text-align: left;
  }
  &.rightAlign {
    text-align: end;
  }
`;

export const SearchWrapper = styled.form`
  display: flex;
  flex: 1;
  align-items: center;
  border: 1px solid ${theme.colors.semantics.info};
  border-radius: 20px;
  background: ${theme.colors.gray['0']};
  padding: 4px 4px 4px 8px;
  position: relative;
  max-width: 550px;
  height: 40px;
`;

export const SearchInput = styled.input`
  background: transparent;
  flex: 1;
  margin-right: 10px;
  padding-left: 12px;
  ::placeholder {
    font-size: 16px;
    color: ${theme.colors.semantics.info};
  }
  :focus {
    box-shadow: none;
  }
`;

export const SearchButton = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.colors.gray['semantics.default']};
  width: 30px;
  height: 30px;
  padding: 8px;
  & > svg {
    width: 24px;
  }
`;
export const StatusWrapper = styled(Flex)`
  padding: 5px 16px;
  border-radius: 13px;
  justify-content: center;
  display: inline-block;
`;
